import { FormSpy } from 'react-final-form';

import { Alert } from '@change/ds-core-ui/Alert';

import { useFormI18n } from '#src/app/shared/form/hooks';
import type { I18nFieldValidatorResult } from '#src/app/shared/form/validators';

export const FormError: React.FC = () => {
	const { getErrorMessage } = useFormI18n();
	return (
		<FormSpy subscription={{ submitError: true, submitting: true }}>
			{({ submitError, submitting }) =>
				submitError && !submitting ? (
					<Alert variant="error" className="mb-4">
						{getErrorMessage(submitError as I18nFieldValidatorResult)}
					</Alert>
				) : null
			}
		</FormSpy>
	);
};
